import React from "react";
import TablaProducto from "js/components/TablaProducto";

export const Producto = props => {
  return <TablaProducto />;
};

export default Producto;
